// Mobile menu category drill-down. Each [data-cat-panel] is one level, rendered flat
// as siblings; only .is-active is shown (display toggled in _header.scss). Drill rows
// are real <a href> links, so without JS they just navigate — the drill is enhancement.
// Panel ids are path-based ("catp-root", "catp-0", "catp-0-2"); a drill link carries
// data-cat-drill="<child panel id>", the back row carries data-cat-back.
(function () {
  var stacks = document.querySelectorAll('[data-cat-stack]');
  if (!stacks.length) return;

  Array.prototype.forEach.call(stacks, initStack);

  function initStack(root) {
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cat-panel]'));
    if (panels.length < 2) return;

    var rootId = 'catp-root';
    var stack = [rootId];

    // Focusable (out of tab order) so focus can follow the active level for keyboard users.
    panels.forEach(function (p) { p.setAttribute('tabindex', '-1'); });

    function show(id) {
      panels.forEach(function (p) {
        var active = p.id === id;
        p.classList.toggle('is-active', active);
        if (active) p.removeAttribute('aria-hidden');
        else p.setAttribute('aria-hidden', 'true');
      });
    }

    function focusActive() {
      var active = document.getElementById(stack[stack.length - 1]);
      if (active) { active.scrollTop = 0; active.focus(); }
    }

    function drillTo(id) {
      if (!document.getElementById(id) || stack[stack.length - 1] === id) return;
      stack.push(id);
      show(id);
      focusActive();
    }

    function back() {
      if (stack.length <= 1) return;
      stack.pop();
      show(stack[stack.length - 1]);
      focusActive();
    }

    function reset() {
      stack = [rootId];
      show(rootId);
    }

    root.addEventListener('click', function (e) {
      var drill = e.target.closest ? e.target.closest('[data-cat-drill]') : null;
      if (drill && root.contains(drill)) {
        e.preventDefault();
        drillTo(drill.getAttribute('data-cat-drill'));
        return;
      }
      var backBtn = e.target.closest ? e.target.closest('[data-cat-back]') : null;
      if (backBtn && root.contains(backBtn)) {
        e.preventDefault();
        back();
      }
    });

    // Reset to root on each open so it starts clean regardless of where it was left.
    var menu = root.closest('[data-mobile-menu]');
    if (menu) {
      var observer = new MutationObserver(function () {
        if (menu.getAttribute('data-state') === 'open' && stack.length > 1) {
          reset();
        }
      });
      observer.observe(menu, { attributes: true, attributeFilter: ['data-state'] });
    }

    show(rootId);
  }
})();
